export enum DracoAvatarShapeValues {
  Square = 'square',
  Circle = 'circle',
};
export type DracoAvatarShapes = `${DracoAvatarShapeValues}`;

export enum DracoAvatarSizeValues {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
};
export type DracoAvatarSizes = `${DracoAvatarSizeValues}`;